/*
 * Moves focus to the form's result when one is on the page.
 *
 * Shopify's contact form is a real post: the browser leaves, submits, and comes back to this page
 * with the result rendered by Liquid. Nothing announces that. The confirmation sits above the fields
 * someone was just looking at, so on a phone it can be off the top of the viewport by the time the
 * page settles, and the visitor is left staring at the same empty form wondering whether it sent.
 *
 * So the result's heading is `tabindex="-1"` in the markup and this moves focus to it, which both
 * scrolls it into view and gives a screen reader the sentence to read. `role="status"` and
 * `role="alert"` on the container already announce it once; focus is what makes it findable
 * afterwards, when the announcement has passed and someone wants to re-read it.
 *
 * One frame of delay, because focusing during parse can be undone by the browser restoring its own
 * scroll position a moment later.
 */
function focusResult() {
  const result = document.querySelector('[data-mediakit-result]');
  if (!result) return;

  const heading = result.querySelector('[tabindex="-1"]');
  if (!heading) return;

  requestAnimationFrame(() => {
    heading.focus({ preventScroll: true });
    /* Smooth, and only when the visitor has not asked for less motion. */
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    heading.scrollIntoView({ behavior: still ? 'instant' : 'smooth', block: 'center' });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', focusResult, { once: true });
} else {
  focusResult();
}
